const getters = {
    withoutDashPhoneNumber(state) {
        return state.identidyInfo.phone.replace(/-/g, '');
    },
    hiddenPartPhoneNumber(state, getters) {
        const number = getters.withoutDashPhoneNumber;
        return `${number.slice(0, 2)}****${number.slice(6)}`;
    },
};

export default getters;